import React from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import moment from 'moment-timezone'
import {
  Alert,
  PageHeader,
  Card,
  Row,
  Col,
  Button,
  FilterTable,
  BrowserStorage,
  RemoteTable
} from 'camino-react'
import Axios from 'axios'

import { humanizeString } from 'Utilities/StringManipulator'

import DescriptionPopup from '../PopupWrapper/DescriptionPopup'

import AlertTableHeaderComponent from './TableHeaderComponent'
import ConvertModal from './ConvertModal'
import { handlers } from './handlers'

let filteredData = []

const statuses = ['Pending', 'Converted', 'Rejected', 'Resolved']

const filterTabs = [
  {
    subject: 'status', type: 'is', value: _.map(statuses, status => (status.toLowerCase())), text: 'All'
  },
  {
    subject: 'status', type: 'is', value: 'pending', text: 'Pending'
  },
  {
    subject: 'status', type: 'is', value: 'converted', text: 'Converted'
  },
  {
    subject: 'status', type: 'is', value: 'rejected', text: 'Rejected'
  },
  {
    subject: 'status', type: 'is', value: 'resolved', text: 'Resolved'
  }
]

class AlertIndex extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      rejectAlertsEndpoint: props.rejectAlertsEndpoint,
      selectedAlerts: [],
      selectedAlertsWithSource: [],
      isSourceTheSame: true,
      modal: null,
      loading: false,
      problemLinkType: null,
      errors: [],
      ownTitleAndDescription: false,
      fields: {
        assigneeId: null,
        teamId: null,
        problemId: null,
        issue: '',
        priority: null,
        bulkMessage: '',
        queueId: null,
        assignToMe: false,
        title: '',
        description: '',
        ticketId: null,
        contactId: null
      },
      alertMessage: {
        alertText: '',
        alertType: ''
      }
    }
    this.handlers = handlers.bind(this)
    this.handleFieldValue = this.handlers.handleFieldValue
  }

  selectRow = (row) => {
    this.setState((prevState) => {
      const { selectedAlerts } = prevState

      return [...selectedAlerts, Object.assign({}, row, row.source)]
    })
  }

  selectAll = (rows) => {
    this.setState((prevState) => {
      const { selectedAlerts } = prevState

      if (!_.isEmpty(selectedAlerts)) { return { selectedAlerts: [] } }

      _.map(rows, row => (Object.assign(row.checked, { value: true })))

      return { selectedAlerts: rows }
    })
  }

  assignTab = (tabIndex) => {
    const tab = filterTabs[tabIndex]

    if (_.isNil(tab)) { return }

    this.setState({ currentTab: tab.text })
  }

  checkIfSourceIsTheSame = () => {
    const { selectedAlertsWithSource } = this.state
    const groupedAlerts = _.groupBy(selectedAlertsWithSource, alert => alert.source)

    this.setState({ isSourceTheSame: !(Object.keys(groupedAlerts).length > 1) })
  }

  formattedContent = string => (
    string.split('\n').map((text, index) => (
      <React.Fragment>
        {text}
        <br />
      </React.Fragment>
    ))
  )

  transformRows (remoteRows) {
    const { selectedAlerts, selectedAlertsWithSource } = this.state
    const alerts = _.map(remoteRows, alert => (
      {
        ...alert,
        description: alert.source_information.description || alert.source_information.message || alert.source_information.Content || alert.source_information.QuantitativeNewState,
        realerted_count: alert.source === 'datto' ? (alert.source_information.triggerCount || 1) : alert.realerted_count,
        first_alerted_at: alert.source === 'datto' ? (alert.source_information.alertTriggered || alert.source_information.lastTriggered) : alert.first_alerted_at,
        last_alerted_at: alert.source === 'datto' ? (alert.source_information.lastTriggered || alert.source_information.alertTriggered) : (alert.source_information.lastDown || alert.last_alerted_at),
        priority: alert.priority || alert.source_information.priority,
        checked: {
          value: _.includes(selectedAlerts.map(a => a.id), alert.id),
          onValue: () => {
            this.setState({
              selectedAlerts: _.includes(selectedAlerts, alert) ? _.filter(selectedAlerts, selectedAlert => (selectedAlert !== alert)) : [...selectedAlerts, alert],
              selectedAlertsWithSource: _.includes(selectedAlerts, alert) ? _.filter(selectedAlertsWithSource, selectedAlert => (selectedAlert !== alert)) : [...selectedAlertsWithSource, Object.assign({}, { id: alert }, { source: alert.source })]
            })
          }
        }
      }
    ))

    return alerts
  }

  render () {
    const {
      selectAll,
      assignTab,
      checkIfSourceIsTheSame,
      selectRow
    } = this

    const {
      handleFieldValue,
      setModal,
      rejectAlerts,
      toggleProblemStatus,
      setTitleAndDescription,
      convertAlerts,
      getTickets,
      handleAssignToMe,
      handleQueue
    } = this.handlers

    const {
      selectedAlerts,
      loading,
      currentTab,
      resolvers,
      rejectors,
      converters,
      alertMessage: {
        alertType,
        alertText
      },
      alerts,
      loadingAlerts
    } = this.state

    const { remoteEndpoint, clientsForSelect } = this.props

    const columns = [
      {
        text: 'ID',
        accessor: 'id',
        defaultWidth: '100',
        maxWidth: '150',
        Cell: row => (
          <a href={`/alerts/${row.original.id}`} target="_blank" rel="noopener noreferrer">
            #
            {row.original.id}
          </a>
        )
      },
      {
        text: 'Source',
        accessor: 'source',
        defaultWidth: '100',
        maxWidth: '150',
        Cell: row => (
          _.upperCase(row.original.source)
        )
      },
      {
        text: 'Affected Service',
        accessor: 'affected_service',
        defaultWidth: '100',
        maxWidth: '150'
      },
      {
        text: 'Device Name',
        accessor: 'device_name',
        defaultWidth: '100'
      },
      {
        text: 'Priority',
        accessor: 'priority',
        defaultWidth: '50'
      },
      {
        text: 'Client',
        accessor: 'client_name',
        defaultWidth: '100'
      },
      {
        text: 'Description',
        accessor: 'source_information.description',
        defaultWidth: '50',
        Cell: row => (<DescriptionPopup row={row} />)
      },
      {
        accessor: 'realerted_count',
        text: 'Realerted count',
        defaultWidth: '50',
        maxWidth: '130'
      },
      {
        accessor: 'first_alerted_at',
        text: 'First alerted at',
        defaultWidth: '50',
        maxWidth: '130',
        Cell: row => (moment(row.value).format('DD MMM YYYY, hh:mmA'))
      },
      {
        accessor: 'last_alerted_at',
        text: 'Last alerted at',
        defaultWidth: '50',
        maxWidth: '130',
        Cell: row => (moment(row.value.replace(' PM', '')).format('DD MMM YYYY, hh:mmA'))
      }
    ]

    const filterSources = [
      { value: 'prtg', label: 'PRTG' },
      { value: 'prtg_na', label: 'PRTG NA' },
      { value: 'datto', label: 'Datto' },
      { value: 'alien_vault', label: 'AlienVault' },
      { value: 'darktrace', label: 'Darktrace' },
      { value: 'ncentral', label: 'Ncentral' },
      { value: 'connect_wise', label: 'ConnectWise' },
      { value: 'email', label: 'Email' }
    ]

    const filterOptions = [
      {
        value: 'Client', type: 'is', subject: 'client_name', values: _.map(clientsForSelect, client => ({ value: client }))
      },
      {
        value: 'AffectedService', type: 'contains', subject: 'affected_service'
      },
      {
        value: 'Device Name', type: 'contains', subject: 'device_name'
      },
      {
        value: 'Source', type: 'is', subject: 'source', values: filterSources
      },
      {
        value: 'Priority', type: 'is', subject: 'priority', values: _.map([1, 2, 3, 4, 5], priority => ({ value: priority }))
      }
    ]

    const firstAlert = selectedAlerts[0]
    let alertsIdsString = ''
    let descriptionByFirstAlert = ''
    let sourceInfo = ''

    if (firstAlert) {
      _.map(firstAlert.source_information, (val, key) => (
        sourceInfo += `\n${_.upperFirst(key)}: ${val}`
      ))

      descriptionByFirstAlert = `${_.upperCase(firstAlert.source)} - ${firstAlert.affected_service} - ${firstAlert.device_name}\n${sourceInfo}`

      _.each(selectedAlerts, (alert) => {
        alertsIdsString += `#${alert.id} `
      })
    }

    if (currentTab === 'All') {
      columns.push({ text: 'Status', accessor: 'status' })
      filterOptions.push({ value: 'Status', type: 'is', values: _.map(statuses, status => (status.toLowerCase())) })
    }

    if (_.includes(['Converted', 'Resolved', 'All'], currentTab)) {
      columns.push(
        {
          text: 'Ticket',
          accessor: 'ticket_id',
          disableHref: true,
          Cell: row => (
            row.original.ticket_id ? <a href={`/tickets/${row.original.ticket_id}`} target="_blank" rel="noopener noreferrer">{row.original.ticket_id}</a> : 'Never converted'
          )
        }
      )
    }

    if (currentTab === 'Resolved') {
      columns.push({ text: 'Resolved by', accessor: 'resolved_by' })
      columns.push({ text: 'Resolved at', accessor: 'resolved_at', Cell: row => (moment(row.value).format('DD MMM YYYY, hh:mmA')) })
      filterOptions.push({ value: 'Resolved by', type: 'is', values: resolvers })
      filterOptions.push({ value: 'Resolved at', subject: 'resolved_at', type: 'between' })
      filterOptions.push({ value: 'Created at', subject: 'created_at', type: 'between' })
    }

    if (currentTab === 'Rejected') {
      columns.push({ text: 'Rejected by', accessor: 'rejected_by' })
      columns.push({ text: 'Rejected at', accessor: 'rejected_at', Cell: row => (moment(row.value).format('DD MMM YYYY, hh:mmA')) })
      filterOptions.push({
        value: 'Rejected by', type: 'is', values: rejectors, subject: 'rejected_by'
      })
      filterOptions.push({ value: 'Rejected at', subject: 'rejected_at', type: 'between' })
      filterOptions.push({ value: 'Created at', subject: 'created_at', type: 'between' })
    }

    if (currentTab === 'Converted') {
      columns.push({ text: 'Converted by', accessor: 'converted_by' })
      columns.push({ text: 'Converted at', accessor: 'converted_at', Cell: row => (moment(row.value).format('DD MMM YYYY, hh:mmA')) })
      filterOptions.push({ value: 'Converted by', type: 'is', values: converters })
      filterOptions.push({ value: 'Converted at', subject: 'converted_at', type: 'between' })
      filterOptions.push({ value: 'Created at', subject: 'created_at', type: 'between' })
    }

    if (_.includes(['Resolved', 'Pending'], currentTab)) {
      columns.push({ text: `${selectedAlerts.length} selected`, accessor: 'checked', type: 'checkbox' })
    }

    filterOptions.push({ value: 'Updated at', subject: 'last_updated', type: 'between' })

    return (
      <>
        <PageHeader
          title="Alerts"
          actions={[
            <Button key="reject" disabled={_.isEmpty(selectedAlerts)} color="danger" onClick={() => rejectAlerts()}>
              Reject
            </Button>,
            <Button
              key="convert"
              disabled={_.isEmpty(selectedAlerts)}
              onClick={() => {
                setModal('convert')
                checkIfSourceIsTheSame()
                handleFieldValue('title', `${_.upperCase(firstAlert.source)} - ${firstAlert.affected_service} - ${firstAlert.device_name}`)
                handleFieldValue('description', `Created by conversion alerts: ${alertsIdsString}\n${descriptionByFirstAlert}`)
              }}
            >
              Convert
            </Button>
          ]}
          breadcrumbs={[{ text: 'Alerts' }]}
        />

        <Row>
          <Col>
            { alertText && (
              <Alert type={alertType} title={alertText ? 'Alerts' : ''}>
                {alertText}
              </Alert>
            ) }
            <Card>
              <RemoteTable
                {...this.props}
                tabs={filterTabs}
                filterOptions={filterOptions}
                selectAll={selectAll}
                HeaderComponent={AlertTableHeaderComponent}
                columns={columns}
                remoteEndpoint={remoteEndpoint}
                loading={loadingAlerts}
                transformFilterOptions={() => filterOptions}
                transformRows={rows => this.transformRows(rows)}
                transformColumns={() => columns}
                pageSizeOptions={[5, 10, 20, 25, 50, 100]}
                defaultPageSize={25}
                storage={{
                  filters: new BrowserStorage('sessionStorage')
                }}
                localStoragePrefix="AlertsTable"
                onManagerChange={({ currentTabIndex }) => assignTab(currentTabIndex)}
                SubComponent={row => (
                  <div style={{ padding: '30px' }}>
                    {row.original.priority && (
                      <div style={{ color: row.original.priorityColor }}>
                        Priority:
                        {' '}
                        {row.original.priority}
                      </div>
                    )}
                    {_.map(row.original.source_information, (val, key) => (
                      <div>
                        {humanizeString(key)}
                        :
                        {' '}
                        {`${val}`}
                      </div>
                    ))}
                  </div>
                )
                }
              >
                {(state, makeTable, instance) => {
                  if (alerts) {
                    filteredData = state.data
                  }
                  return makeTable()
                }}
              </RemoteTable>
            </Card>
          </Col>
        </Row>

        <ConvertModal
          {...this.props}
          {...this.state}
          setModal={setModal}
          toggleProblemStatus={value => toggleProblemStatus(value)}
          setTitleAndDescription={() => setTitleAndDescription()}
          selectRow={selectRow}
          rejectAlerts={rejectAlerts}
          convertAlerts={() => convertAlerts()}
          getTickets={value => getTickets(value)}
          handleFieldValue={(field, value) => handleFieldValue(field, value)}
          handleAssignToMe={value => handleAssignToMe(value)}
          handleQueue={value => handleQueue(value)}
          rejectButtonText={loading ? 'Rejecting...' : 'Reject'}
          convertButtonText={loading ? 'Converting...' : 'Convert'}
        />
      </>
    )
  }
}

AlertIndex.propTypes = {
  remoteEndpoint: PropTypes.string.isRequired,
  rejectAlertsEndpoint: PropTypes.string.isRequired,
  convertAlertsEndpoint: PropTypes.string.isRequired,
  problemPivots: PropTypes.arrayOf(
    PropTypes.shape({}).isRequired
  ).isRequired,
  problemPriorityPivots: PropTypes.arrayOf(
    PropTypes.shape({}).isRequired
  ).isRequired
}

AlertIndex.defaultProps = {
  localStoragePrefix: 'AlertIndex',
  noDataText: 'You currently have no alerts',
  pageSizeOptions: [5, 10, 20, 25, 50, 100],
  defaultPageSize: 25
}

export default AlertIndex
